import {useEffect} from 'react'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {toast} from 'react-toastify'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {getBreadCrumbs} from '../../breadcrumbs'
import {postMember} from '../../../../modules/services/member.service'
import {getListPersona} from '../../../../modules/services/persona.service'
import {useFormik} from 'formik'
import {InputDefault, SelectDefault} from '../../../../components/ui'
import {initialValueMock} from '../../../../mocks'

const MemberCreatePage = () => {
  const queryClient = useQueryClient()
  const {data: personaData} = useQuery('getListPersona', async () => getListPersona())
  const mutation = useMutation(postMember, {
    onSuccess: async () => {
      toast.success('Create Data Success')
      await queryClient.invalidateQueries('getListMember')
    },
    onError(error: any, variables, context) {
      console.log('Error', error.response?.data)
      toast.error(error.response?.data?.error?.message)
    },
  })
  const personaOptions =
    (personaData?.data as Array<any>)?.map((persona) => ({
      value: persona.id,
      label: persona.attributes.name,
    })) || []

  const formik = useFormik({
    initialValues: initialValueMock.member,
    onSubmit: (values) => {
      mutation.mutate(values)
    },
  })

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Create Member</p>
          </div>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className='d-flex flex-column align-items-center gap-4 px-12'>
            <div className='w-100'>
              <label htmlFor='fullname' className='form-label'>
                Full Name
              </label>
              <InputDefault
                type='text'
                id='fullname'
                name='fullname'
                value={formik.values.fullname}
                onChange={formik.handleChange}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='status' className='form-label'>
                Status
              </label>
              <SelectDefault
                id='status'
                name='status'
                label='status'
                options={[
                  {label: 'Belum Menikah', value: 'belum menikah'},
                  {label: 'Menikah', value: 'menikah'},
                  {label: 'Orang Tua Tunggal', value: 'orang tua tunggal'},
                ]}
                value={formik.values.status}
                onChange={(e) => {
                  formik.handleChange(e)
                  formik.setFieldValue('persona', e.target.value === 'belum menikah' ? 1 : 4)
                }}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='persona' className='form-label'>
                Persona
              </label>
              <SelectDefault
                id='persona'
                name='persona'
                label='persona'
                options={personaOptions}
                value={formik.values.persona}
                onChange={formik.handleChange}
                disabled
              />
            </div>
            <div className='w-100'>
              <label htmlFor='gender' className='form-label'>
                Gender
              </label>
              <SelectDefault
                id='gender'
                name='gender'
                label='gender'
                options={[
                  {label: 'Male', value: 'male'},
                  {label: 'Female', value: 'female'},
                ]}
                value={formik.values.gender}
                onChange={formik.handleChange}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='birthdate' className='form-label'>
                Birthdate
              </label>
              <InputDefault
                type='date'
                id='birthdate'
                name='birthdate'
                value={formik.values.birthdate}
                onChange={formik.handleChange}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='phone' className='form-label'>
                Phone Number
              </label>
              <InputDefault
                type='tel'
                id='phone'
                name='phone'
                value={formik.values.phone}
                onChange={formik.handleChange}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='email' className='form-label'>
                Email
              </label>
              <InputDefault
                type='email'
                id='email'
                name='email'
                value={formik.values.email}
                onChange={formik.handleChange}
              />
            </div>
            <div className='w-100'>
              <label htmlFor='password' className='form-label'>
                Password
              </label>
              <InputDefault
                type='password'
                id='password'
                name='password'
                value={formik.values.password}
                onChange={formik.handleChange}
              />
            </div>
          </div>
          <div className='d-flex justify-content-end gap-4 p-12'>
            <button
              type='button'
              id='close-modal'
              className='btn btn-light'
              data-bs-dismiss='modal'
            >
              Cancel
            </button>
            <button type='submit' className='btn btn-primary'>
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

const MemberCreateWrapper = () => {
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('/member-management/member')}>Create Member</PageTitle>
      <MemberCreatePage />
    </>
  )
}

export default MemberCreateWrapper
